<template>
    <div class='header'>
        <p class='name'>{{ name }}</p>
    </div>
</template>

<script>

export default {
    name: 'Header',
    data () {
        return {
            name: ''
        }
    },
    watch: {
    },
    mounted () {
        const self = this
        self.axios.get(`${process.env.API_URL}/name`).then((res) => {
            if (res.data.message === 'OK') {
                self.name = res.data.name
            }
        }).catch((e) => {
            alert('サーバーエラーが発生しました')
        })
    },
    methods: {
    }
}
</script>

<style scoped>

.header {
    display: flex;
    height: 80px;
    padding-top: 15px;
    padding-left: 22px;
    border-bottom: 3px solid #f5f5f5;
}

.name {
    width: 158px;
    font-size: 19px;
    line-height: 50px;
}

.select {
    margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/lab/Header.vue